// src/utils/constants.js

export const PLAN_PRICES = {
  COP: { starter: 25000,  grupo: 35000,  empresa: 50000,  grande: 85000,   masivo: 140000  },
  ARS: { starter: 9000,   grupo: 12500,  empresa: 18000,  grande: 30000,   masivo: 50000   },
  MXN: { starter: 120,    grupo: 170,    empresa: 240,    grande: 410,     masivo: 670     },
  CLP: { starter: 5000,   grupo: 7000,   empresa: 10000,  grande: 17000,   masivo: 28000   },
  PEN: { starter: 22,     grupo: 31,     empresa: 44,     grande: 75,      masivo: 123     },
  BRL: { starter: 30,     grupo: 42,     empresa: 60,     grande: 102,     masivo: 168     },
  USD: { starter: 6,      grupo: 9,      empresa: 13,     grande: 21,      masivo: 35      },
};

export const CURRENCIES = [
  { code: 'COP', label: 'co Colombia (COP)',         symbol: '$',   provider: 'mercadopago', flag: '🇨🇴' },
  { code: 'ARS', label: 'ar Argentina (ARS)',         symbol: '$',   provider: 'mercadopago', flag: '🇦🇷' },
  { code: 'MXN', label: 'mx México (MXN)',            symbol: '$',   provider: 'mercadopago', flag: '🇲🇽' },
  { code: 'CLP', label: 'cl Chile (CLP)',             symbol: '$',   provider: 'mercadopago', flag: '🇨🇱' },
  { code: 'PEN', label: 'pe Perú (PEN)',              symbol: 'S/',  provider: 'mercadopago', flag: '🇵🇪' },
  { code: 'BRL', label: 'br Brasil (BRL)',            symbol: 'R$',  provider: 'mercadopago', flag: '🇧🇷' },
  { code: 'USD', label: '🔵 Pagar con PayPal (USD)', symbol: '$',   provider: 'paypal',      flag: '🔵' },
];

export const PLANS = [
  { id:'free', name:'Gratis', maxMembers:10, price:0, popular:false,
    features:['Hasta 10 participantes','Todos los partidos del Mundial','Tabla de posiciones del grupo','Con anuncios'] },
  { id:'starter', name:'Starter', maxMembers:20, popular:false,
    features:['Hasta 20 participantes','Todo lo del plan Gratis','Sin anuncios','Links únicos de invitación','Predicciones especiales'] },
  { id:'grupo', name:'Grupo', maxMembers:30, popular:true,
    features:['Hasta 30 participantes','Todo lo del plan Starter','Puntos personalizables','Imagen para compartir por partido'] },
  { id:'empresa', name:'Empresa', maxMembers:50, popular:false,
    features:['Hasta 50 participantes','Todo lo del plan Grupo','Panel admin completo','Soporte prioritario'] },
  { id:'grande', name:'Grande', maxMembers:110, popular:false,
    features:['Hasta 110 participantes','Todo lo del plan Empresa','Múltiples admins','Estadísticas avanzadas'] },
  { id:'masivo', name:'Masivo', maxMembers:200, popular:false,
    features:['Hasta 200 participantes','Todo lo del plan Grande','Onboarding personalizado','Llamada de configuración'] },
  { id:'corporativo', name:'Corporativo', maxMembers:9999, price:null, popular:false,
    features:['Más de 200 participantes','Precio a convenir','Todo incluido','Soporte dedicado'] },
];

export const FREE_POINT_RULES = {
  exactScore: 5, exactGoalsPerTeam: 2, goalDiff: 2, winner: 1,
  champion: 0, runnerUp: 0, thirdPlace: 0, fourthPlace: 0, topScorer: 0, nextRound: 0,
};

export const DEFAULT_POINT_RULES = {
  exactScore: 5, exactGoalsPerTeam: 2, goalDiff: 2, winner: 1,
  champion: 15, runnerUp: 10, thirdPlace: 8, fourthPlace: 5, topScorer: 10, nextRound: 3,
};

export const WORLD_CUP_START = new Date('2026-06-11T17:00:00Z');

export const POINT_LABELS = {
  exactScore:        { label: 'Marcador exacto',            icon: '🎯', desc: 'Predices 2-1 y es 2-1', planFree: true },
  exactGoalsPerTeam: { label: 'Goles exactos por equipo',   icon: '⚽', desc: 'Aciertas los goles de uno de los dos equipos', planFree: true },
  goalDiff:          { label: 'Diferencia de gol correcta', icon: '📊', desc: 'La diferencia de goles es correcta', planFree: true },
  winner:            { label: 'Ganador del partido',         icon: '🏆', desc: 'Aciertas quién gana o si hay empate', planFree: true },
  champion:          { label: 'Campeón del torneo',          icon: '🥇', desc: 'Predicción especial — antes del Mundial', planFree: false },
  runnerUp:          { label: 'Subcampeón',                  icon: '🥈', desc: 'Predicción especial — antes del Mundial', planFree: false },
  thirdPlace:        { label: '3er puesto',                  icon: '🥉', desc: 'Predicción especial — antes del Mundial', planFree: false },
  fourthPlace:       { label: '4to puesto',                  icon: '4️⃣', desc: 'Predicción especial — antes del Mundial', planFree: false },
  topScorer:         { label: 'Goleador del torneo',         icon: '👟', desc: 'Predicción especial — antes del Mundial', planFree: false },
  nextRound:         { label: 'Clasificados por grupo',      icon: '➡️', desc: 'Aciertas los 2 clasificados de cada grupo', planFree: false },
};

export const PHASES = {
  GROUPS: 'Grupos', R16: 'Octavos', QF: 'Cuartos',
  SF: 'Semifinal', THIRD: 'Tercer puesto', FINAL: 'Final',
};